import { useRouter } from 'next/navigation'
import React from 'react'
import type { HeaderColorType } from '../Header'
import { HeaderColorEnum } from '../Header'
import styles from './UserButton.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import {
  Button,
  ButtonSize,
  ButtonVariants,
  IconButton,
  IconButtonSize,
  PersonIcon,
} from '@/tools/ui'
import { useUserData } from '@/user/useUserData'

interface Props {
  color?: HeaderColorType
  isMobile?: boolean
  isIntersecting: boolean
}

export const UserButton: React.FC<Props> = ({ isMobile = false, color, isIntersecting }) => {
  const router = useRouter()
  const { t, getLanguage } = useLocalisation()
  const { userData } = useUserData()

  const handleLoginClick = () => {
    router.push(`/${getLanguage()}/login`)
  }

  const handleProfileClick = () => {
    router.push(`/${getLanguage()}/profile`)
  }

  const colorButton =
    color === HeaderColorEnum.background || isIntersecting
      ? ButtonVariants.neutral
      : ButtonVariants.floating

  const userName = userData?.name.split(' ')[0]

  return userData?.id ? (
    isMobile ? (
      <IconButton
        aria-label={t('profile.title')}
        icon={PersonIcon}
        size={IconButtonSize.small}
        variant={colorButton}
        onClick={handleProfileClick}
      />
    ) : (
      <Button
        className={styles.profileButton}
        label={userName}
        leadingIcon={PersonIcon}
        size={ButtonSize.small}
        variant={colorButton}
        onClick={handleProfileClick}
      />
    )
  ) : (
    <Button
      label={t('login.title-unified')}
      leadingIcon={isMobile ? undefined : PersonIcon}
      size={ButtonSize.small}
      onClick={handleLoginClick}
    />
  )
}
